import { Serializable, SerializationHelper } from "@/helpers/SerializationHelper";
import { Quantity } from "@/model/Quantity";
import { PreparationType } from "@/model/preparation/PreparationType";
import {OrderedProductStatus} from "@/model/OrderedProductStatus";

export class PreparationOrderProduct implements Serializable {
    orderLineNumber: number;
    cug: string;
    description: string;
    origin: string;
    thumbnail: string;
    quantity: Quantity;
    preparationType: PreparationType;
    sourceOrderId: string;
    preparedQuantity: Quantity;
    processedQuantity: Quantity;
    status: OrderedProductStatus;

    fromJSON(rawObject: any): void {
        SerializationHelper.copyNonExcludedProperties(this, rawObject, ['quantity', 'preparedQuantity', 'processedQuantity']);

        if (rawObject['quantity'] != null) {
            this.quantity = SerializationHelper.toInstanceFromJsonObj(new Quantity(), rawObject['quantity']);
        }
        if (rawObject['preparedQuantity'] != null) {
            this.preparedQuantity = SerializationHelper.toInstanceFromJsonObj(new Quantity(), rawObject['preparedQuantity']);
        }
        if (rawObject['processedQuantity'] != null) {
            this.processedQuantity = SerializationHelper.toInstanceFromJsonObj(new Quantity(), rawObject['processedQuantity']);
        }
    }

    get isProcessed(): boolean {
        return this.processedQuantity != null && this.processedQuantity.value > 0;
    }
}
